import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Hängt Popup-Inhalte an `document.body` — Pendant dazu, dass Syncfusion seine
 * Popups außerhalb des auslösenden Elements rendert (REQ-06 §2).
 */
export interface PortalProps {
  children: ReactNode;
  /** Zielelement; standardmäßig `document.body`. */
  container?: Element | null;
}

export function Portal(props: PortalProps) {
  const container = props.container ?? (typeof document === 'undefined' ? null : document.body);
  if (container === null) return null;

  return createPortal(props.children, container);
}

export default Portal;
